import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { UXActions } from "../actions/uxActions";

export default function fullscreenReducer(state = initialState.fullscreen, action: UXActions): boolean {
    switch (action.type) {
        case types.FULLSCREEN_UPDATED: {
            return action.fullscreen;
        }
        default:
            return state;
    }
}
